import { ZoneType } from "@src/core/features/zones/entites";
import TemporaryIcon from '@src/core/features/zones/components/zones-control/assets/temporary-marker.png';
import PermanentIcon from '@src/core/features/zones/components/zones-control/assets/permanent-marker.png';

export const iconByType = {
  [ZoneType.TEMPORARY]: TemporaryIcon,
  [ZoneType.PERMANENT]: PermanentIcon,
};